<div class="document-manager">
  <!-- Upload Section -->
  <app-document-upload
    *ngIf="!readOnlyDocumentUpload"
    [disabled]="isUploading"
    [isUploading]="isUploading"
    (filesSelected)="onFilesSelected($event)"
    (uploadError)="onUploadError($event)"
  >
  </app-document-upload>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ "loading" | translate }}...</span>
    </div>
  </div>

  <!-- Documents Timeline -->
  <app-document-timeline
    *ngIf="!isLoading && !readOnlyDocumentTimeline"
    [documentGroups]="documentGroups"
    [woundGroups]="woundDocumentGroups"
    [groupByWound]="groupByWound"
    (previewRequested)="onPreviewRequested($event)"
    (downloadRequested)="onDownloadRequested($event)"
    (deleteRequested)="onDeleteRequested($event)"
  >
  </app-document-timeline>

  <!-- Preview Modal -->
  <app-document-preview
    *ngIf="showPreview && previewDocument && !readOnlyDocumentPreview"
    [document]="previewDocument"
    (closeRequested)="closePreview()"
    (downloadRequested)="onDownloadRequested($event)"
  >
  </app-document-preview>
</div>
